let saleSliderWrapper = document.getElementById('saleslider')
if (saleSliderWrapper) {
	let saleSliderCount = saleSliderWrapper.children.length - 1
	let saleSliderCurrent = 0
	const intervalFunc = () => {
		saleSliderCurrent = saleSliderCurrent < saleSliderCount ? (saleSliderCurrent + 1) : 0;
		[...saleSliderWrapper.children].forEach(slide => {
			slide.style.transform = `translateX(-${saleSliderCurrent * 100}%)`
			slide.style.webkitTransform = `translateX(-${saleSliderCurrent * 100}%)`
		});
	}
	var saleSliderInterval = setInterval(intervalFunc, 5000)
	saleSliderWrapper.addEventListener('mouseenter', function() {
		clearInterval(saleSliderInterval)
	})
	saleSliderWrapper.addEventListener('mouseleave', function() {
		saleSliderInterval = setInterval(intervalFunc, 5000)
	})
}

const toggleBrands = async (element) => {
	const ids = [...document.getElementsByClassName('brand-checkbox')].map(box => {
		if (box.checked) {
			return box.getAttribute('data-brand-id')
		}
	})
	fIds = ids.filter(id => id !== undefined)
	const minPrice = document.getElementById('min-price').value
	const maxPrice = document.getElementById('max-price').value
	if (fIds.length === 0) {
		alert('Er moet minimaal één merk geselecteerd worden')
		element.checked = true
		return
	}
	const catId = element.getAttribute('data-cat-id')
	const response = await fetch(`
		${ajaxJsObj.restURL}xldiscounter/v1/products-by-brand
		?ids=${ids}
		&cat_id=${catId}
		&price_filter=${minPrice},${maxPrice}
		`,
		{
			headers: {
				'X-WP-Nonce': ajaxJsObj.restNonce
			},
		}
	)
	const result = await response.json()
	const ul = document.getElementsByClassName('products')[0]
	ul.parentElement.innerHTML = result.template
}

const filterPrices = async (catId) => {
	const brandIds = [...document.getElementsByClassName('brand-checkbox')].map(box => {
		if (box.checked) {
			return box.getAttribute('data-brand-id')
		}
	})
	const fBrandIds = brandIds.filter(id => id !== undefined)
	const minPrice = document.getElementById('min-price').value
	const maxPrice = document.getElementById('max-price').value
	const response = await fetch(`
		${ajaxJsObj.restURL}xldiscounter/v1/products-by-brand
		?ids=${fBrandIds}
		&cat_id=${catId}
		&price_filter=${minPrice},${maxPrice}
		`,
		{
			headers: {
				'X-WP-Nonce': ajaxJsObj.restNonce
			},
		}
	)
	const result = await response.json()
	const ul = document.getElementsByClassName('products')[0]
	ul.parentElement.innerHTML = result.template
}

const alterQuantity = (e, dir) => {
	const input = e.target.parentElement.getElementsByTagName('input')[0]
	try {
		if (Number(input.value) > 0) {
			const newVal = dir === 'up' ? Number(input.value) + 1 : Number(input.value) - 1
			input.value = newVal === 0 ? input.value : newVal
			document.getElementsByName('update_cart')[0].removeAttribute('disabled')
			document.getElementsByName('update_cart')[0].click()
			
			const int = setInterval(() => {
				if (document.getElementsByClassName('woocommerce-cart-form')[0].classList.contains('processing')) {
					return
				}
				const cartContents = document.getElementsByClassName('woocommerce-cart__content')[0]
				const cartContentsImages = [...cartContents.getElementsByTagName('img')]
				const nonLoadedImages = cartContentsImages.filter(img => !img.classList.contains('loaded'))
				if (nonLoadedImages.length === 0) {
					clearInterval(int)
					return
				}
				nonLoadedImages.forEach(img => {
					if (img.hasAttribute('data-src')) {
						img.src = img.getAttribute('data-src')
					}
				})
			}, 100)
		}
	} catch (e) {
		console.error(e)
	}
}


const handleWindowClicks = e => {
	switch (e.target.id) {
		case 'woocommerce-myaccount-mobile-navtoggle':
		case 'woocommerce-myaccount-mobile-navtoggle-text':
		case 'woocommerce-myaccount-mobile-navtoggle-img':
			document.getElementsByClassName('woocommerce-MyAccount-navigation')[0].classList.toggle('active')
			break
		case 'mobile-toggle-search':
		case 'mobile-toggle-search__img':
			const parts = [...document.getElementsByClassName('mainheader-searchpart')].forEach(part => {
				part.classList.toggle('active')
			})
			break
	}
}

window.addEventListener('click', handleWindowClicks);

function searchFormSubmit(e) {
	e.preventDefault();
	const term = e.target.getElementsByClassName('mainheader-search__input')[0].value
	if (term === '') {
		return false
	}
	window.location = `${window.location.origin}?s=${term}`
}

window.addEventListener('DOMContentLoaded', function() {
	const mainheader = document.getElementById('mainheader')
	const productMenu = document.getElementById('header-productmenu')
	const scrollingHeaderWrapper = document.getElementById('scrolling-header-wrapper')
	const mainheaderOffset = mainheader.getBoundingClientRect().top + window.scrollY
	scrollingHeaderWrapper.innerHTML = mainheader.outerHTML + productMenu.outerHTML

	function stickyHeader() {
		if (window.scrollY > mainheaderOffset) {
			document.body.classList.add('is-sticky')
		} else {
			document.body.classList.remove('is-sticky')
		}
	}
	
	window.addEventListener('scroll', stickyHeader)
})
